import { render, staticRenderFns } from "./HeroesGrid.vue?vue&type=template&id=1bf9692d&lang=pug&"
import script from "./HeroesGrid.vue?vue&type=script&lang=js&"
export * from "./HeroesGrid.vue?vue&type=script&lang=js&"
import style0 from "./HeroesGrid.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VForm,VLayout,VPagination,VProgressLinear,VTextField})
